/**
 * Quantities are integer unit counts and money is integer cents, everywhere.
 *
 * Floating point is banned from both domains: `0.1 + 0.2 !== 0.3` quietly
 * corrupts totals. Every value crossing a boundary — DB column, API payload,
 * React prop — is an int.
 *
 * This shop used to sell by weight, on a 100g grid. It sells cans of drink, so
 * "100g of Coca-Cola" was always a fiction dressed up as precision. A unit is a
 * can, and the grid is gone: the smallest sale is one.
 */
/** You cannot buy half a can. */
export const MIN_ORDER_UNITS = 1;
/**
 * The largest quantity one line may hold.
 *
 * Pack pricing is solved by a dynamic program over the quantity, so the cost of
 * pricing a line is linear in it. A crafted request asking for two billion units
 * would otherwise ask the server to allocate two billion array slots before any
 * stock check could reject it. Ten thousand is far above any real basket and far
 * below anything that costs measurable time.
 */
export const MAX_LINE_UNITS = 10_000;
/** True when a quantity is a whole number of units within the allowed range. */
export function isValidOrderQuantity(units) {
    return Number.isSafeInteger(units) && units >= MIN_ORDER_UNITS && units <= MAX_LINE_UNITS;
}
export function isValidUnits(value) {
    return Number.isSafeInteger(value) && value >= 0;
}
export function isValidCents(value) {
    return Number.isSafeInteger(value) && value >= 0;
}
export function assertUnits(value, label = 'quantity') {
    if (!isValidUnits(value)) {
        throw new RangeError(`${label} must be a non-negative whole number of units, got ${value}`);
    }
    return value;
}
export function assertCents(value, label = 'amount') {
    if (!isValidCents(value)) {
        throw new RangeError(`${label} must be a non-negative whole number of cents, got ${value}`);
    }
    return value;
}
//# sourceMappingURL=units.js.map